import type { IObjectIdService } from './interfaces/i-object-id.service'

import { injectable } from 'inversify'

@injectable()
export class ObjectIdService implements IObjectIdService {
  private _counter: number

  public constructor(private _ids: Record<string, object> = {}) {
    this._counter = 0
  }

  getId(object: object): string {
    let id = Object.keys(this._ids).find((searchId: string) => this._ids[searchId] === object)
    if (!id) {
      id = this._counter.toString()
      this._ids[id] = object
      this._counter++
    }
    return id
  }
}
